import { Menu, MenuItem } from "@mui/material";
import { NestedMenuItem } from "mui-nested-menu";
import React, { useState } from "react";

const CascadingDropdown = ({
  options,
  setIsMenuOpen,
  triggerComponent: TriggerComponent,
  title,
  isTriggerComponentDisabled = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    if (isTriggerComponentDisabled) {
      return;
    }
    setAnchorEl(event.currentTarget);
    setIsMenuOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsMenuOpen(false);
  };

  const commonStyles = {
    fontSize: "var(--font-size-sm)",
    fontFamily: "var(--font-family-body)",
    color: "var(--text-primary)",
  };

  const commonStylesWithHover = {
    ...commonStyles,
    backgroundColor: "var(--surface-secondary)",
    "&:hover": {
      color: "var(--text-primary)",
      backgroundColor: "var(--surface-tertiary)",
    },
  };

  const paperStyles = {
    backgroundColor: "var(--surface-secondary)",
    borderRadius: "var(--radius-standard)",
    boxShadow: "0px 0px 10px 0px var(--shadow-primary)",
  };

  return (
    <div data-testid={`cascading-dropdown-container-${title}`}>
      <div
        onClick={handleOpen}
        data-testid={`trigger-component-wrapper-${title}`}
      >
        <TriggerComponent
          data-testid={`trigger-component-${title}`}
        />
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          "& .MuiPaper-elevation": paperStyles,
        }}
        slotProps={{
          root: {
            sx: commonStyles,
          },
          list: {
            sx: commonStyles,
          },
          paper: {
            sx: commonStyles,
          },
        }}
        data-testid={`menu-${title}`}
      >
        {options?.map((option, index) =>
          option.items ? (
            <NestedMenuItem
              key={index}
              label={<span style={commonStyles}>{option.label}</span>}
              parentMenuOpen={Boolean(anchorEl)}
              MenuProps={{
                sx: {
                  ...commonStyles,
                  "& .MuiPaper-elevation": paperStyles,
                },
              }}
              sx={{
                ...commonStylesWithHover,
                "&.Mui-focusVisible": {
                  outline: "none",
                  backgroundColor: "inherit",
                },
                "&[tabindex='0']": {
                  tabindex: -1,
                },
              }}
              data-testid={`customization-option-parent-${title}-${index}`}
            >
              {option.items?.map((childOption, childIndex) => (
                <MenuItem
                  key={childIndex}
                  onClick={(event) => {
                    handleClose();
                    childOption.callback &&
                      childOption.callback(event, childOption);
                  }}
                  sx={commonStylesWithHover}
                  tabIndex={-1}
                  data-testid={`customization-option-${title}-${index}-${childIndex}`}
                >
                  {childOption.label}
                </MenuItem>
              ))}
            </NestedMenuItem>
          ) : (
            <MenuItem
              key={index}
              onClick={(event) => {
                handleClose();
                option.callback && option.callback(event, option);
              }}
              sx={commonStylesWithHover}
              tabIndex={-1}
              data-testid={`customization-option-${title}-${index}`}
            >
              {option.label}
            </MenuItem>
          ),
        )}
      </Menu>
    </div>
  );
};

export default CascadingDropdown;
